import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { PrizeDetail } from '@swf/core/types/CasinoRaces';
import { PrizeType } from '@swf/core/types/CasinoRaces';

import {
  TXTWCL_Wagering_Requirements_XbXN0_Re_ELL,
  TXTWCL_Winning_Paid_As_XbXCashX_bX,
  TXTWCL_Winning_Paid_As_XbXInstant_Bon_ELL
} from './PaidInfo.messages.json';

export interface Props {
  prizeDetails: PrizeDetail;
}

const PaidInfo: React.FC<Props> = ({ prizeDetails }) => {
  const site = useSelector(select.cms.getSiteId);
  const siteIT = site === Sites.ITA;
  const { formatNumber } = useIntl();

  if (prizeDetails.prizeType === PrizeType.IB) {
    return (
      <Translation
        {...TXTWCL_Wagering_Requirements_XbXN0_Re_ELL}
        values={{
          0: siteIT ? 1 : 0.1,
          1: formatNumber(1, {
            currency: prizeDetails.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            style: 'currency'
          })
        }}
      />
    );
  } else if (prizeDetails.prizeType === PrizeType.FSB) {
    return siteIT ? (
      <Translation {...TXTWCL_Winning_Paid_As_XbXInstant_Bon_ELL} />
    ) : (
      <Translation {...TXTWCL_Winning_Paid_As_XbXCashX_bX} />
    );
  }

  return null;
};

export default PaidInfo;
